<button
    aria-label="Delete"
    tabindex="-1"
    class="delete-btn"
    (click)="$event.stopPropagation(); deleteRecord()"
>
    <fa-icon
        [icon]="faIconName.faTrashCan"
        class="trash-can"
    ></fa-icon>
</button>
